module.exports = __webpack_public_path__ + "static/media/23.8bee956d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/23.jpg
// module id = 184
// module chunks = 0